import Vue from 'vue'
import * as types from './mutation-types'
import * as R from 'ramda'

export default {
  [types.PUSH_MENU] (state, { menu }) {
    if (!state.menus[menu.variation]) {
      Vue.set(state.menus, menu.variation, { title: menu.variationTitle })
    }
    Vue.set(state.menus[menu.variation], menu.version, menu.data)
  },
  [types.SET_LATEST_RECORD] (state, { variation, version }) {
    Vue.set(state.latestVersions, variation, version)
  },
  [types.SET_MENU_VARIATIONS] (state, variations) {
    Vue.set(state, 'menuVariations', variations)
  },
  [types.SET_MENU_STORE_ID] (state, id) {
    state.menuStoreId = id
  },
  [types.RESET_MENUS] (state) {
    state.menuStoreId = null
    Vue.set(state, 'latestVersions', {})
    Vue.set(state, 'menus', {})
    Vue.set(state, 'menuVariations', [])
  },
  [types.SET_BUSINESS_HOURS] (state, { menuVariation, businessHours }) {
    Vue.set(state.businessHours, menuVariation, businessHours)
  },
  [types.CREATE_BUSINESS_HOUR] (state, { menuVariation, weekdayIndex }) {
    const businessHour = R.append(['00:00', '00:00'])(state.businessHours[menuVariation][weekdayIndex])
    Vue.set(state.businessHours[menuVariation], weekdayIndex, businessHour)
  },
  [types.SET_BUSINESS_HOUR] (state, { menuVariation, weekdayIndex, index, interval }) {
    Vue.set(state.businessHours[menuVariation][weekdayIndex], index, interval)
  },
  [types.SET_BUSINESS_HOUR_DIRTY] (state, { menuVariation, dirty }) {
    Vue.set(state.businessHourDirtyStates, menuVariation, dirty)
  },
  [types.DELETE_BUSINESS_HOUR] (state, { menuVariation, weekdayIndex, index }) {
    Vue.delete(state.businessHours[menuVariation][weekdayIndex], index)
  }
}
